module.exports = __webpack_public_path__ + "img/6_dice[5].10f5cb40.png";